import { Vue } from 'vue-property-decorator';
import VueI18n from 'vue-i18n';
import dataLanguages, { defaultLocale } from '@/data/languages';

Vue.use(VueI18n);
export default new VueI18n({
  locale: localStorage.lang,
  fallbackLocale: defaultLocale,
  messages: dataLanguages.reduce(
    (acc, lang) => ({ ...acc, [lang.locale]: lang.messages }),
    {}
  ),
});
